import { lightTheme } from "../../../theme/theme";
type Theme = typeof lightTheme;

export const ServiceDetailsStyles = (theme: Theme, isMobile: boolean) => {
  const accent = `var(--accent, ${theme.primary})`;

  return {
    page: {
      backgroundColor: theme.background,
      color: theme.text,
      fontFamily: "'Poppins', sans-serif",
    },
    breadcrumbWrap: {
      maxWidth: 1140,
      margin: "8px auto 0",
      padding: "0 16px",
    },

    breadcrumbNav: {
      maxWidth: 1140,
      margin: "0 auto",
      padding: "12px 16px 0",
    },
    breadcrumbOl: {
      listStyle: "none",
      margin: 0,
      padding: 0,
      display: "flex",
      flexWrap: "wrap" as const,
      gap: 4,
      alignItems: "center",
      fontSize: 15,
    },
    breadcrumbItem: {
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
    breadcrumbLink: {
      color: theme.primary,
      textDecoration: "none",
      fontWeight: 600,
    },
    breadcrumbSep: {
      opacity: 0.45,
      userSelect: "none" as const,
    },
    breadcrumbCurrent: {
      opacity: 0.7,
      fontWeight: 600,
    },
    relatedGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: 12,
      marginTop: 12,
    },
    relatedLink: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 8,
      padding: "14px 16px",
      borderRadius: 12,
      border: `1px solid ${accent}33`,
      background: `${accent}08`,
      textDecoration: "none",
      color: theme.text,
      fontWeight: 600,
      fontSize: 14,
    },

    backLink: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "6px 10px",
      borderRadius: 999,
      border: `1px solid ${theme.primary}33`,
      background: `${theme.primary}0A`,
      color: theme.text,
      textDecoration: "none",
      fontSize: 13,
      fontWeight: 600,
      marginBottom: 8,
    },
    // ServiceDetailsStyles

    backTextLink: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      fontSize: 13,
      fontWeight: 600,
      color: theme.text,
      textDecoration: "none",
      opacity: 0.75,
    },
    backIcon: {
      fontSize: 16,
      lineHeight: 1,
      marginInlineEnd: 2,
    },

    hero: {
      background: `linear-gradient(180deg, ${accent}1A 0%, transparent 60%)`,
    },
    heroInner: {
      maxWidth: 1140,
      margin: "0 auto",
      padding: "40px 16px 0 16px",

      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1.1fr .9fr",
      gap: 24,
      alignItems: "center",
    },
    processList: {
      listStyle: "none",
      padding: 0,
      margin: "12px 0 0",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: 16,
      alignItems: "start",
    },
    processItem: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      background: `${theme.primary}08`,
      border: `1px solid ${theme.primary}22`,
      borderRadius: 12,
      padding: "12px 14px",
    },
    stepBadge: {
      minWidth: 34,
      height: 34,
      borderRadius: "999px",
      display: "grid",
      placeItems: "center",
      fontWeight: 700,
      border: `1px solid ${theme.primary}55`,
      background: theme.background,
      color: theme.text,
    },
    stepLabel: {
      fontSize: 14,
      lineHeight: 1.35,
      fontWeight: 600,
      color: theme.text,
      // optional: clamp long lines
      // display: "-webkit-box",
      // WebkitLineClamp: 2,
      // WebkitBoxOrient: "vertical",
      // overflow: "hidden",
    },
    badge: {
      display: "inline-flex",
      padding: "6px 12px",
      borderRadius: 999,
      background: `${accent}14`,
      border: `1px solid ${accent}44`,
      fontWeight: 600,
      fontSize: 12,
      letterSpacing: 0.5,
      textTransform: "uppercase" as const,
    },

    title: {
      margin: "10px 0 6px",
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontStyle: "italic",
      fontSize: "clamp(28px, 6vw, 44px)",
      lineHeight: 1.12,
    },
    subtitle: { opacity: 0.9, fontSize: 16 },
    des: {
      paddingTop: 30,
    },
    // media
    mediaBox: {
      borderRadius: 16,
      overflow: "hidden",
      border: `1px solid ${accent}33`,
      boxShadow: "0 10px 30px rgba(0,0,0,.12)",
    },

    // features
    section: { maxWidth: 1140, margin: "10px auto 0", padding: "10px 16px" },
    sectionTitle: {
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 600,
      fontStyle: "italic",
      fontSize: "clamp(20px, 3vw, 28px)",
      marginBottom: 12,
    },
    bullets: { display: "grid", gap: 8, paddingInlineStart: 16 },

    // specs table
    specs: {
      border: `1px solid ${accent}33`,
      borderRadius: 12,
      overflow: "hidden",
    },
    specRow: {
      display: "grid",
      gridTemplateColumns: "180px 1fr",
      gap: 12,
      padding: "10px 12px",
      borderTop: `1px solid ${accent}22`,
    },
    specLabel: { fontWeight: 700 },
    specFirst: { borderTop: "none" },

    // process strip
    processRow: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(160px,1fr))",
      gap: 10,
    },
    processStep: {
      padding: 12,
      borderRadius: 12,
      border: `1px solid ${accent}33`,
      background: `${accent}06`,
      fontSize: 14,
    },

    // faq
    faqItem: {
      border: `1px solid ${accent}33`,
      borderRadius: 12,
      padding: 12,
    },
    faqQ: { fontWeight: 700, marginBottom: 6 },
    faqCol: { display: "grid", gap: 10 },

    // final cta
    finalCta: {
      maxWidth: 1140,
      margin: "28px auto 40px",
      padding: 16,
      borderRadius: 16,
      border: `1px solid ${accent}44`,
      background: `linear-gradient(180deg, ${accent}14 0%, ${accent}06 100%)`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      flexWrap: "wrap" as const,
    },
    btnPrimary: {
      textDecoration: "none",
      backgroundColor: accent,
      color: theme.hoverText,
      padding: "10px 16px",
      borderRadius: 12,
      fontWeight: 700,
      border: `1px solid ${accent}`,
    },

    // add near the other sections
    categoryGrid: {
      display: "flex",
      flexWrap: "wrap",
      gap: 8,
    },
    categoryTag: {
      display: "inline-flex",
      alignItems: "center",
      padding: "6px 10px",
      borderRadius: 999,
      border: `1px solid ${accent}33`,
      background: `${accent}10`,
      fontSize: 13,
      fontWeight: 600,
    },
    categoryGroup: {
      border: `1px solid ${accent}33`,
      borderRadius: 12,
      padding: 12,
      marginBottom: 10,
    },
    categoryTitle: {
      marginBottom: 8,
      fontSize: 18,
      fontWeight: 700,
    },
    categoryList: {
      margin: 0,
      paddingInlineStart: 18,
      display: "grid",
      gap: 4,
    },

    // NEW / tweaked
    tagsRow: {
      display: "flex",
      flexWrap: "wrap" as const,
      gap: 8,
      marginTop: 10,
    },

    tagPill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "6px 10px",
      borderRadius: 0,
      fontSize: 12,
      fontWeight: 600,
      background: theme.text2,

      color: theme.background,
      boxShadow: "0 2px 8px rgba(0,0,0,.06)",
      whiteSpace: "nowrap" as const,
    },
    typePill: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      padding: "8px 20px",
      borderRadius: 999,
      background: `${accent}14`,
      border: `1px solid ${accent}44`,

      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 600,
      fontStyle: "italic",
      fontSize: "clamp(20px, 3vw, 28px)",
      marginBottom: 10,
    },

    subtypePill: {
      background: `${accent}0E`,
      display: "inline-flex",
      alignItems: "center",
      border: `1px solid ${accent}33`,

      gap: 8,
      paddingBottom: 10,
      borderRadius: 999,
      padding: "10px 20px",

      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 600,
      fontStyle: "italic",
      fontSize: "clamp(20px, 3vw, 28px)",
    },

    sectionDesc: { marginTop: 6 },
    sectionPara: {
      fontSize: 15,
      lineHeight: 1.7,
      opacity: 0.95,
      margin: "4px 0",
    },
    pointsList: { margin: "6px 0 0", paddingInlineStart: 18, display: "grid", gap: 4 },
    subtypeBlock: { marginTop: 8 },
    // responsive
    "@media(max-width: 900px)": {
      heroInner: { gridTemplateColumns: "1fr", gap: 16 },
    } as any,
  } as const;
};
